import { render } from "./ResultsListnew.vue?vue&type=template&id=d0825fdc&scoped=true"
import script from "./ResultsListnew.vue?vue&type=script&lang=js"
export * from "./ResultsListnew.vue?vue&type=script&lang=js"

import "./ResultsListnew.vue?vue&type=style&index=0&id=d0825fdc&lang=scss"
import "./ResultsListnew.vue?vue&type=style&index=1&id=d0825fdc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0825fdc"]])

export default __exports__